const InputError = ({ error }) => {
  if (error) {
    return <small className="input__error">{error}</small>;
  }
};

export default InputError;
